<bn-loading-overlay></bn-loading-overlay>
<h5>Irregularidade Operacional</h5>
<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            
            <div class="col-auto" *ngIf="podeCadastrarIrregularidade">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/irregularidade']" 
                  ngbTooltip="Tela para cadastro de Irregularidade Operacional."><i class="fa fa-file-signature">
                  </i> Cadastrar nova Irregularidade
                </button>
            </div> 

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>      

            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()" (click)="buscar()"
                    [disabled]="!pesquisaForm.valid" >Pesquisar
                </button>
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-8">
                <label class="form-label">Agente Financeiro:</label>
                <select class="form-select" name="agenteFinanceiro" ngDefaultControl formControlName="agenteFinanceiro">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let agente of agentesFinanceiros" 
                        [ngValue]="agente">{{ agente.nome }}
                    </option>
                </select>  
            </div>      

            <div class="bn-form-group col-md-4">
                <label class="form-label">Situação:</label>
                <select class="form-select" name="situacao" ngDefaultControl formControlName="situacao">
                    <option value=null>Todos</option>
                    <option value="S">Em aberto</option>
                    <option value="N">Finalizada</option>
                </select>  
            </div> 
        </div>

        <div class="row">
          
            <div class="bn-form-group col-md-3">
                <label class="form-label">Tipo Operação/Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></label>
                <select class="form-select" name="classeOperacao" ngDefaultControl formControlName="classeOperacao">
                    <option [ngValue]='null'>Todos</option>
                    <option *ngFor="let classeOperacao of classesOperacao" 
                        [ngValue]="classeOperacao.codigo">{{ classeOperacao.nome }}
                    </option>
                </select>  
            </div>

            <div class="bn-form-group col-md-2">
                <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro
                        (em operações Crédito Livre) ou o identificador de protocolo do BNDES Online (em operações de Repasse BNDES)."></i></label>
                    <input class="form-control" name="idOperacaoExterno" ngDefaultControl formControlName="idOperacaoExterno">
            </div>

            <div class="bn-form-group col-md-2">
                <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i></label>
                <input class="form-control" name="contratoRepasse" ngDefaultControl formControlName="contratoRepasse">
            </div>
        
            <div class="bn-form-group col-md-3">
                <label class="form-label">Período de vigência: Início</label>
                <bn-datepicker 
                    name="dataDesativacaoInicial" 
                    idInput="dataDesativacaoInicial" 
                    ngDefaultControl
                    formControlName="dataDesativacaoInicial" >
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-2">
                <label class="form-label">Período de vigência: Fim</label>
                <bn-datepicker
                    name="dataDesativacaoFinal" 
                    idInput="dataDesativacaoFinal" 
                    ngDefaultControl
                    formControlName="dataDesativacaoFinal">
                </bn-datepicker>

            </div>      
            
        </div>
        <div class="row">
            <div class="bn-form-group col-md-12">
                <label class="form-label">Motivo:</label>
                <input class="form-control" name="motivo" ngDefaultControl formControlName="motivo">
            </div>
        </div>
    </form>
</div>


<ng-template #desativacao>
    <h5>Deseja realmente desativar a irregularidade abaixo ?</h5>
    <div class="row">
        <div class="bn-form-group col-md-12">
            <label for="agenteIrregularDesativacao"><b>Agente</b></label>
            <input readonly type="text" class="form-control" id="agenteIrregularDesativacao" name="agenteIrregularDesativacao"
                value="{{ retornaAgenteFinanceiro(irregularidadeDesativando.idAgenteFinanceiro).nome }}" />
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-6">
            <label for="classeOperacaoIrregularDesativacao"><b>Tipo Operação/Sistema</b></label>
            <select name="classeOperacaoIrregularDesativacao" id="classeOperacaoIrregularDesativacao" class="form-select"
                [ngValue]="irregularidadeDesativando.sistemaRepasse" disabled>
                <option *ngFor="let classeOperacao of classesOperacao" [ngValue]="classeOperacao.codigo">{{
                    classeOperacao.nome }}
                </option>
            </select>

        </div>
        <div class="bn-form-group col-md-6">
            <label for="dataPublicacao"><b>Publicado em</b></label>
            <input readonly type="text" class="form-control" id="dataPublicacao" name="dataPublicacao"
                value="{{ irregularidadeDesativando.dataEnvio | date: 'dd/MM/yyyy HH:mm' }}" />

        </div>
        <div class="bn-form-group col-md-12">
            <label for="nomeUsuarioEnvio"><b>Enviado por </b></label>
            <input readonly type="text" class="form-control" id="nomeUsuarioEnvio" name="nomeUsuarioEnvio" class="form-control"
                value="{{ irregularidadeDesativando.nomeUsuarioEnvio }}" />
        </div>

        <div class="bn-form-group col-md-12">
            <label for="irregularidadeDesativacaoMensagem"><b>Mensagem</b></label>
            <textarea name="irregularidadeDesativacaoMensagem" id="irregularidadeDesativacaoMensagem" rows="3" class="form-control" disabled
                value="{{ irregularidadeDesativando.mensagem }}"></textarea>
        </div>

        
    </div>

    <div class="row">
        <div class="bn-form-group col-md-6" >
            <label for="dataInicio"><b>Inicio da Irregularidade</b></label>
            <input readonly type="text" class="form-control" id="dataInicioIrregularidade" name="dataInicioIrregularidade"
                value="{{ irregularidadeDesativando.dataInicio | date: 'dd/MM/yyyy' }}" />
        </div>

        <div class="bn-form-group col-md-6" >
            <label for="dataFim"><b>Desativando Irregularidade Em</b></label>
            <input readonly type="text" class="form-control" id="dataEncerramento" name="dataEncerramento"
                value="{{ irregularidadeDesativando.dataFim | date: 'dd/MM/yyyy' }}" />
        </div>

    </div>
</ng-template>
<ng-template #desativacaoBotoes>
    <button class="btn btn-default" (click)="cancelaDesativacao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmaDesativacao()">Confirmar</button>
</ng-template>



<app-irregularidade-listagem
    *ngIf="pesquisado"
    [hidden]="esconderPesquisa"
    [irregularidades]="irregularidades"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    [dataHoraResultado]="dataHoraResultado"
    [podeCadastrarIrregularidade]="podeCadastrarIrregularidade"
    (aoRequererDesativacao)="desativacaoIrregularidade($event)"
    (aoMudarPagina)="mudancaPagina($event)">
</app-irregularidade-listagem>